'use strict';

module.exports = emphasis;

var all = require('../all');

/* Transform emphasis. */
function emphasis(h, node) {
  return h(node, 'em', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/emphasis.js
// module id = 219
// module chunks = 96961042003272 139266963665775